import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { WEBFORMS_FORM_CONVERTER_TOKEN, WebformsFormConverter } from './webforms-form.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        webformsFormFeature: {
          module: () => import('./webforms-form.module').then((m) => m.WebformsFormModule),
          cmsComponents: ['form'],
        },
      }
    }),
    {
      provide: WEBFORMS_FORM_CONVERTER_TOKEN,
      useClass: WebformsFormConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        form: WEBFORMS_FORM_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class WebformsFormFeatureModule {}
